import { format } from 'date-fns';
export const getDefaultDate18YearsAgo = () => {
  const today = new Date();
  const year = today.getFullYear() - 18;
  const month = today.getMonth();
  const day = today.getDate();
  const defaultDate = new Date(year, month, day);
  return format(defaultDate, 'yyyy-MM-dd');
};
